import { XStack, YStack, View, Text } from "tamagui";
import { RiArrowRightSLine } from "react-icons/ri";
import { colors } from "@styles/colors";

interface StatBoxProps {
  label: string;
  value: string;
  sub?: string;
  valueColor?: string;
  icon?: React.ReactNode;
  alert?: boolean;
  onPress?: () => void;
}

/** 統計小卡：標題 + 數值 + 註解，可點擊 */
export default function StatBox({ label, value, sub, valueColor = colors.text, icon, alert, onPress }: StatBoxProps) {
  return (
    <YStack
      bg={colors.light}
      br={9}
      px="$3"
      py="$3"
      bw={1.5}
      bc={alert ? `${colors.danger}40` : colors.borderLight}
      cursor={onPress ? "pointer" : "default"}
      onPress={onPress}>
      <XStack ai="center" gap="$1.5" mb="$1.5">
        {icon}
        <Text fontSize={11} fontWeight="600" color={alert ? colors.danger : colors.sub}>
          {label}
        </Text>
        {onPress && (
          <View ml="auto">
            <RiArrowRightSLine size={14} color={colors.hint} />
          </View>
        )}
      </XStack>
      <Text fontSize={17} fontWeight="800" color={valueColor} style={{ fontVariantNumeric: "tabular-nums" }}>
        {value}
      </Text>
      {sub && (
        <Text fontSize={10} color={colors.hint} mt="$1.5">
          {sub}
        </Text>
      )}
    </YStack>
  );
}
